document.addEventListener('DOMContentLoaded', function () {
  setTimeout(async function () {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');

    if (!variantId) return;

    let product;

    try {
      product = await fetch(window.location.pathname + '.js').then(function (response) {
        return response.json();
      });
    } catch (error) {
      console.warn('No se pudo cargar la información del producto:', error);
      return;
    }

    const variant = product.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (!variant) {
      console.warn('La variante de la URL no existe en este producto:', variantId);
      return;
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (!productForm) return;

    const variantInput = productForm.querySelector('[name="id"]');

    if (variantInput) {
      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const selects = document.querySelectorAll('select');

    selects.forEach(function (select) {
      Array.from(select.options).forEach(function (option) {
        const optionText = option.textContent.toLowerCase();
        const variantSku = String(variant.sku || '').toLowerCase();
        const variantTitle = String(variant.title || '').toLowerCase();

        if (
          (variantSku && optionText.includes(variantSku)) ||
          (variantTitle && optionText.includes(variantTitle))
        ) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    console.log('Variante seleccionada desde URL:', variant);
  }, 500);
});

(function () {
  function getVariantIdFromUrl(url) {
    try {
      const parsedUrl = new URL(url, window.location.origin);
      return parsedUrl.searchParams.get('variant');
    } catch (error) {
      return null;
    }
  }

  function syncSearchCardVariant(card) {
    if (!card || card.dataset.variantCardSynced === 'true') return;

    const select = card.querySelector('select[name="id"]');

    if (!select) return;

    const variantLink = card.querySelector('a[href*="variant="]');

    if (!variantLink) return;

    const variantId = getVariantIdFromUrl(variantLink.href);

    if (!variantId) return;

    const optionExists = Array.from(select.options).some(function (option) {
      return String(option.value) === String(variantId);
    });

    if (!optionExists) return;

    select.value = variantId;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    card.dataset.variantCardSynced = 'true';
  }

  function syncAllSearchCards() {
    const selects = document.querySelectorAll('select.product-grid-item-b2b__variant-select, select[name="id"]');

    selects.forEach(function (select) {
      const card =
        select.closest('.product-grid-item') ||
        select.closest('.productitem') ||
        select.closest('.product-card') ||
        select.closest('li') ||
        select.closest('div');

      syncSearchCardVariant(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(syncAllSearchCards, 500);
    setTimeout(syncAllSearchCards, 1500);
  });

  window.addEventListener('load', function () {
    setTimeout(syncAllSearchCards, 500);
  });
})();